import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { FaHome, FaCalendar, FaSignOutAlt, FaTasks, FaCheckCircle, FaPauseCircle, FaExclamation, FaUserFriends } from 'react-icons/fa';
import imagen2 from '../img/get_view2.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const handleInicioClick = () => navigate('/menustaff');
  const handleMisAsignacionesClick = () => navigate('/MisAsignaciones');
  const handleEnRevisionClick = () => navigate('/AsignacionesEnRevision');
  const handleEnPausaClick = () => navigate('/AsignacionesEnPausa');
  const handleFinalizadasClick = () => navigate('/ActividadesFinalizadasStaff');
  const handleCompletadasClick = () => navigate('/Completadas_staff');
  

  const handleExitClick = () => {
    navigate('/'); // Redirige al usuario a la página de inicio de sesión o la ruta principal
    localStorage.clear(); // Elimina todos los elementos de localStorage
    window.location.reload(); // Refresca la página
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img src={imagen2} alt="GET View Logo" className="sidebar-logo" />
      </div>
      <div className="sidebar-section">
        <p>Aplicaciones</p>
        <div className="profile-link" onClick={handleInicioClick}>
          <FaHome /> Inicio
        </div>
        <div className="profile-link" onClick={handleMisAsignacionesClick}>
          <FaTasks /> Mis asignaciones
        </div>
        <div className="profile-link" onClick={handleEnPausaClick}>
          <FaPauseCircle /> Mis asignaciones en pausa
          </div>
        <div className="profile-link" onClick={handleEnRevisionClick}>
          <FaCalendar /> Asignaciones en revisión
        </div>
        <div className="profile-link" onClick={handleFinalizadasClick}>
          <FaExclamation /> Asignaciones anuladas
        </div>
        <div className="profile-link" onClick={handleCompletadasClick}>
          <FaCheckCircle /> Asignaciones finalizadas
        </div>
      </div>
      <div className="sidebar-section bottom-items">
        <p>Otros</p>
        <div className="profile-link" onClick={handleExitClick}>
          <FaSignOutAlt /> Cerrar Sesión
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
